import { render } from "./CardCharacter.vue?vue&type=template&id=5cc636e4"
import script from "./CardCharacter.vue?vue&type=script&lang=js"
export * from "./CardCharacter.vue?vue&type=script&lang=js"

import "./CardCharacter.vue?vue&type=style&index=0&id=5cc636e4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__